export default {
  date: 'Data',
  chooseExpDate: 'Wybierz datę',
  filterExpDate: 'Filtruj według daty',
  experienceType: 'Typ',
  filterExperienceType: 'Filtruj według typu',
  experienceVibe: 'Klimat',
  filterExperienceVibe: 'Filtruj według klimatu',
  search: 'Szukaj',
  viewCalendar: 'Kalendarz',
  back: 'Wstecz',
  previous: 'Poprzedni',
  next: 'Następny',
  noExperiences: 'Brak doświadczeń',
  cancelChanges: 'Anuluj zmiany',
  saveChanges: 'Zapisz zmiany',
  removeFromReservation: 'Usuń z rezerwacji',
  addToCart: 'Dodaj do koszyka',
  proceedToCheckout: 'Przejdź do realizacji zamówienia',
  selectDate: 'Wybierz datę',
  startDate: 'Data rozpoczęcia',
  endDate: 'Data zakończenia',
  submit: 'Wyślij',
  filterExperienceTypeScreenReader:
    'Użyj tych filtrów, aby zawęzić wyniki. Treść aktualizuje się automatycznie po wybraniu filtra.',
};
